module.exports = __webpack_public_path__ + "static/media/rounded-rect-quaternary.d72b6e46.png";